import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const usePartnerActiveOpportunities = () => {
  return useQuery({
    queryKey: ["partner-active-opportunities"],
    queryFn: async () => {
      console.log("🔍 [usePartnerActiveOpportunities] Fetching active opportunities for partners");
      
      const { data, error } = await supabase
        .from('crm_deals')
        .select(`
          id,
          status,
          archived,
          stage_id,
          assigned_to_partner_id,
          created_by_partner_id,
          contact:profiles!crm_deals_contact_id_fkey(
            external_owner_id
          ),
          stage:crm_deal_stages(name)
        `)
        .eq('archived', false)
        .neq('status', 'won')
        .neq('status', 'lost');
      
      if (error) {
        console.error("❌ [usePartnerActiveOpportunities] Error:", error);
        throw error;
      }
      
      // Filter for deals associated with partners and in active stages
      const activeOpportunities = data.filter(deal => {
        // Check if deal is associated with a partner
        const hasPartnerAssociation = 
          deal.assigned_to_partner_id || 
          deal.created_by_partner_id || 
          (deal.contact?.external_owner_id);
        
        // Check if deal is in active stage (Opportunity or Proposal) or has null stage_id
        const hasActiveStage = !deal.stage_id || 
          (deal.stage?.name === 'Opportunity' || deal.stage?.name === 'Proposal');
        
        return hasPartnerAssociation && hasActiveStage;
      });
      
      console.log("✅ [usePartnerActiveOpportunities] Active opportunities:", activeOpportunities.length);
      return activeOpportunities.length;
    },
    staleTime: 10000,
    gcTime: 5 * 60 * 1000,
  });
};